import { useLang } from 'hooks/lang';

import { getStatusConfig, loaders } from 'entities';

import { Column, Skeleton, Card, Row, Button, IconButton } from 'components/Blocks';
import { GoBackButton } from 'components/Buttons';
import { EntityStatusTag } from 'components/Entities';
import {
  ArrowRightIcon,
  ChevronUpIcon,
  ExpandIcon,
  MessageHeartCircleIcon,
  ZeroDataIcon,
} from 'components/Icons';
import { MultiLineText } from 'components/MultiLineText';
import { AttachedFiles } from 'components/Uploads';

import { useUser } from 'hooks';

import { getTimePassed } from 'utils/date';
import { SuggestionModal, useSuggestionModal } from '../components';

export default function MySuggestions() {
  const { t } = useLang();
  const user = useUser();

  const suggestions = loaders.feedback.userSuggestions.use({
    defaultValue: [],
    params: { userId: user.id },
    refreshMinutes: 2,
  });

  const { openSuggestion } = useSuggestionModal();

  return (
    <>
      <SuggestionModal />

      <Column>
        <Column gap="2">
          <h5 className="flex items-center gap-2 text-3xl font-medium text-primary">
            <GoBackButton />
            {t('my-suggestions')}
          </h5>
        </Column>

        <Button to="userSuggestions" variant="link" className="-mt-2 ml-auto w-fit">
          {t('user-suggestions')}
          <ArrowRightIcon />
        </Button>

        {suggestions.errorOrLoading ? (
          <Skeleton quantity={8} height={42} />
        ) : suggestions.data.length ? (
          <Column>
            {suggestions.data.map((suggestion) => (
              <Card key={suggestion.id} flow="column" gap="3">
                <Row gap="2">
                  <MessageHeartCircleIcon
                    color={getStatusConfig('userSuggestion', suggestion.status).color}
                  />

                  <EntityStatusTag
                    target="userSuggestion"
                    status={suggestion.status}
                    round={false}
                    className="w-fit"
                  />

                  <span className="ml-1 text-sm">{suggestion.upVotes.length + 1}</span>
                  <ChevronUpIcon size={12} />

                  <IconButton onClick={() => openSuggestion(suggestion.id)}>
                    <ExpandIcon size={12} />
                  </IconButton>

                  <span className="ml-auto text-xs">{getTimePassed(suggestion.timestamp)}</span>
                </Row>

                <h5 className="text-lg">{suggestion.title}</h5>

                <Column gap="1">
                  <MultiLineText
                    text={suggestion.text}
                    renderLine={(line) => (
                      <p className="max-w-[95ch] text-justify leading-relaxed">{line}</p>
                    )}
                  />
                </Column>

                <AttachedFiles files={suggestion.files} />
              </Card>
            ))}
          </Column>
        ) : (
          <Column gap="2" alignItems="center" className="p-2">
            <ZeroDataIcon size={36} color="primary" />

            <p className=" font-medium">No data found</p>
          </Column>
        )}
      </Column>
    </>
  );
}
